/**
 * Shared constants for the v2 editor block palette (the left-hand drag source).
 *
 * The palette is edit-mode only and will eventually back both the fund
 * opportunity content editor and the fund update editor. It renders as a fixed
 * overlay (a collapsible left flyout, or a bottom sheet on narrow viewports) so
 * it never reduces the width the content is rendered at.
 */

/**
 * `dataTransfer` MIME type set when a block is dragged out of the palette. The
 * drop target (canvas) is not wired up yet — this is defined now so the drag
 * payload is stable once it is.
 */
export const PALETTE_DRAG_MIME = 'application/x-fides-content-block';

/** Width, in px, of the open flyout panel on desktop. */
export const PALETTE_PANEL_WIDTH = 320;

/**
 * Top offset, in px, for the desktop flyout (and the collapsed edge tabs'
 * stack) — lands level with the content editor toolbar's own top edge: the
 * admin header (80px) + MainLayoutBase's extra top padding (10px,
 * CONTENT_TOP_PADDING_EXTRA). The toolbar's own mt:3 (24px) doesn't add to
 * this — it's the first thing in MainLayoutBase's content area, so its
 * top margin collapses into MainLayoutBase's own rather than stacking on
 * top of it.
 */
export const PALETTE_HEADER_OFFSET = 90;

/** Height of the palette bottom sheet on narrow viewports. */
export const PALETTE_SHEET_HEIGHT = '46vh';

/**
 * `dataTransfer` MIME type set when a video is dragged out of the sidebar's
 * media tab; the payload is the video asset's externalId. Slide cards and the
 * "New slide" tile accept it as a drop.
 */
export const LIBRARY_VIDEO_DRAG_MIME = 'application/x-fides-library-video';
